'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = _interopDefault(require('react'));
var PropTypes = _interopDefault(require('prop-types'));

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(source, true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(source).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

var BUILT_IN_PROPS = {
  origKey: true,
  key: true,
  ref: true,
  descriptor: true,
  type: true,
  dirtyFlag: true,
  token: true,
  $internal: true
};

function getOverrides(originalProps, props) {
  var overrides = null;
  Object.keys(props).filter(function (prop) {
    return !BUILT_IN_PROPS.hasOwnProperty(prop) && originalProps[prop] !== props[prop];
  }).forEach(function (prop) {
    overrides = overrides || {};
    overrides[prop] = props[prop];
  });
  return overrides;
}

var createForwardRef = function createForwardRef(CarmiObserver) {
  var Component = function Component(props, forwardedRef) {
    var _props$$internal = props.$internal,
        observerProps = _props$$internal.observerProps,
        originalProps = _props$$internal.originalProps,
        forwardProps = _objectWithoutProperties(props, ["$internal"]);

    var overrides = getOverrides(originalProps, forwardProps);
    return React.createElement(CarmiObserver, _objectSpread2({}, observerProps, {
      overrides: overrides,
      forwardedRef: forwardedRef
    }));
  };

  var forwardRef = React.forwardRef(Component);
  forwardRef.displayName = 'CarmiForwardRef';
  Component.propTypes = {
    $internal: PropTypes.shape({
      observerProps: PropTypes.object,
      originalProps: PropTypes.object
    }).isRequired
  };
  return forwardRef;
};

var privatesByPointer = new WeakMap();
var pointerByInstance = new WeakMap();
function getPrivatesByPointer(pointer) {
  if (!privatesByPointer.has(pointer)) {
    var privates = {
      descriptorToCompsMap: new WeakMap(),
      descriptorToElementsMap: new WeakMap(),
      pendingFlush: new Set(),
      compsLib: {},
      root: null,
      flush: function flush() {
        if (privates.root.lastChildren !== privates.root.props.children()) {
          privates.root.setState({});
        }

        privates.pendingFlush.forEach(function (comp) {
          comp.setState({});
        });
        privates.pendingFlush.clear();
      }
    };
    privatesByPointer.set(pointer, privates);
  }

  return privatesByPointer.get(pointer);
}

function createPointerToInstanceIfNeeded(instance) {
  if (!pointerByInstance.has(instance)) {
    pointerByInstance.set(instance, {});
  }
}

function getPrivatesByInstance(instance) {
  createPointerToInstanceIfNeeded(instance);
  return getPrivatesByPointer(pointerByInstance.get(instance));
}
function getPointerToInstance(instance) {
  createPointerToInstanceIfNeeded(instance);
  return pointerByInstance.get(instance);
}

var CarmiContext = React.createContext(null);
var CarmiRoot =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CarmiRoot, _React$Component);

  function CarmiRoot(props) {
    var _this;

    _classCallCheck(this, CarmiRoot);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(CarmiRoot).call(this, props));
    _this.lastChildren = null;
    return _this;
  }

  _createClass(CarmiRoot, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          value = _this$props.value,
          children = _this$props.children;
      var privates = getPrivatesByInstance(value);
      privates.root = this;
      this.lastChildren = children();
      value.$addListener(privates.flush);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(newProps) {
      return newProps.children() !== this.lastChildren;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var children = this.props.children;
      this.lastChildren = children();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var value = this.props.value;
      var privates = getPrivatesByInstance(value);
      value.$removeListener(privates.flush);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          children = _this$props2.children;
      return React.createElement(CarmiContext.Provider, {
        value: value
      }, children());
    }
  }]);

  return CarmiRoot;
}(React.Component);
CarmiRoot.propTypes = {
  children: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired
};

var getMaybeKey = function getMaybeKey(props, name) {
  return props && props.hasOwnProperty(name) ? props[name] : null;
};

var parseDescriptor = function parseDescriptor(descriptor) {
  var type = descriptor[0];
  var props = descriptor[1] || {};
  var children = descriptor.slice(2);
  var childrenList = children && Array.isArray(children[0]) && children.length === 1 ? children[0] : children;

  var rawKey = props.key,
      extraProps = _objectWithoutProperties(props, ["key"]);

  var key = getMaybeKey(props, 'key');
  return {
    type: type,
    props: props,
    children: children,
    childrenList: childrenList,
    rawKey: rawKey,
    extraProps: extraProps,
    key: key
  };
};

var wrapElement = function wrapElement(wrappers, element, children) {
  return wrappers.reduce(function (wrappedElement, wrapper) {
    return wrapper(wrappedElement, children);
  }, element);
};

function replaceElementProps(_ref, newProps) {
  var props = _ref.props;
  Object.assign(props, newProps);
  Object.keys(props).forEach(function (prop) {
    if (!newProps.hasOwnProperty(prop) && !BUILT_IN_PROPS.hasOwnProperty(prop)) {
      delete props[prop]; // eslint-disable-line no-param-reassign
    }
  });
}

var registerInstance = function registerInstance(comp) {
  var privates = getPrivatesByPointer(comp.props.token);

  if (!privates.descriptorToCompsMap.has(comp.props.descriptor)) {
    privates.descriptorToCompsMap.set(comp.props.descriptor, new Set());
  }

  privates.descriptorToCompsMap.get(comp.props.descriptor).add(comp);
};

var CarmiObserver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(CarmiObserver, _React$Component);

  function CarmiObserver() {
    _classCallCheck(this, CarmiObserver);

    return _possibleConstructorReturn(this, _getPrototypeOf(CarmiObserver).apply(this, arguments));
  }

  _createClass(CarmiObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var dirtyFlag = this.props.dirtyFlag;
      registerInstance(this);

      if (dirtyFlag[0]) {
        this.setState({});
      }
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var _this$props = this.props,
          dirtyFlag = _this$props.dirtyFlag,
          overrides = _this$props.overrides;
      return nextProps.dirtyFlag !== dirtyFlag || nextProps.dirtyFlag[0] || nextProps.overrides !== overrides;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props2 = this.props,
          descriptor = _this$props2.descriptor,
          dirtyFlag = _this$props2.dirtyFlag;

      if (prevProps.descriptor !== descriptor) {
        registerInstance(this);
      }

      if (dirtyFlag[0]) {
        this.setState({}); // eslint-disable-line react/no-did-update-set-state
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _this$props3 = this.props,
          token = _this$props3.token,
          descriptor = _this$props3.descriptor;
      var privates = getPrivatesByPointer(token);
      privates.pendingFlush.delete(this);

      if (!privates.descriptorToCompsMap.has(descriptor)) {
        privates.descriptorToCompsMap.set(descriptor, new Set());
      }

      privates.descriptorToCompsMap.get(descriptor).delete(this);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props4 = this.props,
          dirtyFlag = _this$props4.dirtyFlag,
          descriptor = _this$props4.descriptor,
          overrides = _this$props4.overrides,
          token = _this$props4.token;
      dirtyFlag[0] = false;

      var _parseDescriptor = parseDescriptor(descriptor),
          type = _parseDescriptor.type,
          children = _parseDescriptor.children,
          originalProps = _parseDescriptor.props;

      var props = null;

      if (originalProps || overrides) {
        props = originalProps ? _objectSpread2({}, originalProps, {}, overrides) : overrides;

        if (props.hasOwnProperty('style')) {
          props.style = _objectSpread2({}, props.style);
        }
      }

      var privates = getPrivatesByPointer(token);
      var Component = privates.compsLib[type] || type;
      return React.createElement.apply(React, [Component, props].concat(_toConsumableArray(children)));
    }
  }]);

  return CarmiObserver;
}(React.Component);

CarmiObserver.contextType = CarmiContext;
CarmiObserver.defaultProps = {
  overrides: null
};
CarmiObserver.propTypes = {
  dirtyFlag: PropTypes.arrayOf(PropTypes.bool).isRequired,
  descriptor: PropTypes.arrayOf(PropTypes.any).isRequired,
  token: PropTypes.any.isRequired,
  overrides: PropTypes.object
};
var CarmiForwardRef = createForwardRef(CarmiObserver);

function createNewElement(observerProps, originalProps) {
  var rawKey = originalProps.key,
      extraProps = _objectWithoutProperties(originalProps, ["key"]);

  var compProps = _objectSpread2({}, extraProps, {}, observerProps, {
    $internal: {
      originalProps: originalProps,
      observerProps: observerProps
    }
  });

  var rawElement = React.createElement(CarmiForwardRef, compProps); // sorry about doing it but
  // we short circuit the reconciliation code of React
  // and we need to mutate the props in place
  // so a parent component that is aware of the expected props
  // of a child can access them, even if they changed since the
  // last time React.createElement was triggered

  var element = _objectSpread2({}, rawElement);

  element.props = _objectSpread2({}, rawElement.props);
  return element;
}

var createElement = function createElement(instance, descriptor, wrappers) {
  var _parseDescriptor2 = parseDescriptor(descriptor),
      type = _parseDescriptor2.type,
      props = _parseDescriptor2.props,
      childrenList = _parseDescriptor2.childrenList,
      extraProps = _parseDescriptor2.extraProps,
      key = _parseDescriptor2.key;

  var privates = getPrivatesByInstance(instance);
  var currentElement = privates.descriptorToElementsMap.get(descriptor);

  if (currentElement && currentElement.props.type === type && getMaybeKey(currentElement.props, 'origKey') === key) {
    // Element is mounted
    currentElement.props.dirtyFlag[0] = true;

    if (privates.descriptorToCompsMap.get(descriptor)) {
      privates.descriptorToCompsMap.get(descriptor).forEach(function (comp) {
        return privates.pendingFlush.add(comp);
      });
    }

    replaceElementProps(currentElement, extraProps);
  } else {
    var dirtyFlag = [true];
    var observerProps = {
      descriptor: descriptor,
      type: type,
      dirtyFlag: dirtyFlag,
      token: getPointerToInstance(instance)
    };

    if (key !== null) {
      observerProps.origKey = key;
      observerProps.key = key;
    }

    var newElement = createNewElement(observerProps, props);
    privates.descriptorToElementsMap.set(descriptor, newElement);
  }

  var element = privates.descriptorToElementsMap.get(descriptor);
  return wrapElement(wrappers, element, childrenList);
};

function Provider(_ref) {
  var children = _ref.children,
      value = _ref.value,
      compsLib = _ref.compsLib;
  var privates = getPrivatesByInstance(value);
  privates.compsLib = compsLib;
  return React.createElement(CarmiRoot, {
    value: value
  }, children);
}
Provider.defaultProps = {
  compsLib: {}
};
Provider.propTypes = {
  children: PropTypes.func.isRequired,
  value: PropTypes.object.isRequired,
  compsLib: PropTypes.object
};
function getFunctionsLibrary() {
  var customWrappers = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  return {
    createElement: function createElement$1(descriptor) {
      return createElement(this, descriptor, customWrappers);
    }
  };
}
var carmiReactFnLib = getFunctionsLibrary();

exports.Provider = Provider;
exports.carmiReactFnLib = carmiReactFnLib;
exports.getFunctionsLibrary = getFunctionsLibrary;
